module.exports = __webpack_public_path__ + "static/img/5_v2.7e31ab68.png";